import React,{ Component } from 'react';
import { Row, Col, ButtonGroup, Button, Alert } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alert: null,
            dateFrom: '',
            dateTo: '',
            affid: null,
            list: null,
            feed: null,
            subid: null,
            country: null,
            minClicks: null,
            minSpent: null
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFieldChange(event) {
        const { value,name } = event.target;

        this.setState({ [name]: value });
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm();

        if(isValid) {
            const filters = Object.assign({}, this.state);
            delete filters.alert;

            this.props.onSubmit(type, filters);
        }
    }

    validateForm() {
        const { affid, dateFrom, dateTo } = this.state;

        let alert = null;

        if(!dateFrom) alert = 'Please set Date From';
        else if(!dateTo) alert = 'Please set Date To';
        else if(dateFrom > dateTo) alert = 'Date range invalid!';
        else if(!affid) alert = 'Please choose network';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={{ 264: 'Eureekkaa', 265: 'Ad Maven' }}
                            label="Network:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.feedValues}
                            label="Feed:"
                            name="feed"
                            onChange={this.handleFieldChange}
                            value={this.state.feed}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={{ WL: 'White list', BL: 'Black list'}}
                            label="List:"
                            name="list"
                            onChange={this.handleFieldChange}
                            value={this.state.list}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                    <Col lg={3}>
                        <FieldGroup
                            type="number"
                            name="minClicks"
                            label="Min. Clicks:"
                            onChange={this.handleFieldChange}
                            value={this.state.minClicks}
                        />
                    </Col>
                    <Col lg={3}>
                        <FieldGroup
                            type="number"
                            name="minSpent"
                            label="Min. Spent:"
                            onChange={this.handleFieldChange}
                            value={this.state.minSpent}
                        />
                    </Col>
                </Row>
                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('feed')}>Load Feed</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('country')}>Load Country</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('subid')}>Load Subid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit()}>Load Report</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/AdKernel/components/Form/index.js